<template>
  <b-modal
    ref="modal-bill-excel"
    hide-footer
    :title="titleExcel"
    id="modal-bill-excel"
    @shown="getHistoryExportExcel()"
  >
    <b-row class="mb-4">
      <b-col cols="12">
        <b-form-group label="Danh sách cần xuất:">
          <b-form-radio-group v-model="selectedListExcel">
            <b-form-radio value="all">Tất cả các trang</b-form-radio>
            <b-form-radio value="filter">Theo bộ lọc</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Misa:">
          <b-form-checkbox v-model="selectedMisa"
            >Xuất theo hoá đơn misa</b-form-checkbox
          >
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Fast:">
          <b-form-checkbox v-model="selectedFast"
            >Xuất theo hoá đơn fast</b-form-checkbox
          >
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-row v-if="selectedListExcel === 'all'">
          <b-col md="4">
            <b-form-group>
              <label>Từ ngày:</label>
              <date-picker
                placeholder="Từ ngày"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="apiParams.fromDate"
              ></date-picker>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Đến ngày:</label>
              <date-picker
                placeholder="Tới ngày"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="apiParams.toDate"
              ></date-picker>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <div>
      <hr
        class="hr-text"
        data-content="Lịch sử xuất excel"
        style="font-weight: 600"
      />
      <b-table
        class="myTable"
        caption-top
        responsive
        bordered
        hover
        :fields="fieldHistory"
        :items="histories"
        id="my-table"
      >
        >
        <template #cell(name)="row">
          {{ row.item.name }}
        </template>
        <template v-slot:cell(actions)="row">
          <v-icon
            v-if="
              +row.item.processingStatus ===
                PROCESSING_DOWNLOAD_STATUS.COMPLETED
            "
            small
            class="text-primary"
            title="Tải xuống"
            v-b-tooltip
            @click="downloadExcel(row.item.id)"
            >mdi-download</v-icon
          >

          <div 
            v-else-if="
              +row.item.processingStatus ===
                PROCESSING_DOWNLOAD_STATUS.PROCESSING
            "
            class="d-flex align-items-center"
          >
            <b-progress
              height="20px"
              class="mt-3 flex-grow-1"
            >
              <b-progress-bar
                :value="row.item.process"
                :label="`${row.item.process}%`"
                :animated="isDownloading"
                variant="success"
              ></b-progress-bar>
            </b-progress>
            <v-icon
              small
              class="text-danger ml-2 mt-3"
              title="Dừng tải xuống"
              v-b-tooltip
              :disabled="isSubmitting('cancel-' + row.item.id)"
              :style="
                isSubmitting('cancel-' + row.item.id)
                  ? 'cursor: pointer; pointer-events: none'
                  : 'cursor: pointer'
              "
              @click="cancelDownload(row.item.id)"
            >mdi-close</v-icon>
          </div>
          <span v-else>Lỗi</span>
        </template>
      </b-table>
    </div>
    <b-overlay
      :show="
        isSubmitting('export') ||
        isDownloading ||
        Object.keys(this.pollingIntervals).length
      "
      rounded
      opacity="0.6"
      class="d-inline-block mr-3"
      @hidden="$refs.button.focus()"
    >
      <template #overlay>
        <div class="d-flex align-items-center">
          <b-spinner variant="light" small type="grow"></b-spinner>
        </div>
      </template>
      <b-button
        variant="primary"
        size="sm"
        :disabled="isSubmitting('export')"
        @click="exportExcel"
      >
        <v-icon small class="text-white" v-b-tooltip>mdi-download</v-icon>
        <strong>Xuất Excel</strong>
      </b-button>
    </b-overlay>

    <b-button
      style="width: 80px"
      variant="secondary"
      size="sm"
      :disabled="isSubmitting('export')"
      @click="$bvModal.hide('modal-bill-excel')"
    >
      <strong>Hủy</strong>
    </b-button>
  </b-modal>
</template>

<script>
// import Swal from 'sweetalert2';
import { validationMixin } from 'vuelidate';
// import { minLength } from 'vuelidate/lib/validators';

// import { currencyMask, unMaskPrice } from './../../utils/common';
import { checkPermissions } from '../../../utils/saveDataToLocal';
import { makeToastFaile, makeToastSuccess } from '../../../utils/common';
import { PROCESSING_DOWNLOAD_STATUS } from '../../../utils/enum';
// import { ORDER_STATUS, ORDER_CANCEL_STATUS } from '../../../utils/constants';
import ApiService from '@/core/services/api.service';
import fileDownload from '../../../utils/file-download';
import datePicker from 'vue-bootstrap-datetimepicker';
// Import date picker css
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import moment from 'moment';
import submitLock from '@/view/mixins/submit-lock.mixins';
export default {
  props: ['param', 'mode'],
  mixins: [validationMixin, submitLock],
  data() {
    return {
      PROCESSING_DOWNLOAD_STATUS,
      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      selectedListExcel: 'all',
      apiParams: null,
      titleExcel: 'Xuất excel hoá đơn bán lẻ',
      types: [],
      isDownloading: false,
      selectedMisa: false,
      selectedFast: false,
      pollingIntervals: {},
      fieldHistory: [
        {
          key: 'name',
          label: 'Tên File',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '80%' },
          tdClass: 'text-center',
        },
        { key: 'actions', label: '', tdClass: 'text-center' },
      ],
      histories: [],
    };
  },
  components: {
    datePicker,
  },
  computed: {},
  created() {},
  mounted() {
    this.getHistoryExportExcel();
  },
  watch: {
    $props: {
      handler() {
        switch (this.mode) {
          case 1:
            this.titleExcel = 'Xuất excel hoá đơn bán lẻ';
            this.types = [1, 4];
            break;
          case 2:
            this.titleExcel = 'Xuất excel hoá đơn bán buôn';
            this.types = [2];
            break;
          case 3:
            this.titleExcel = 'Xuất excel hoá đơn trả hàng';
            this.types = [3];
            break;
          default:
            this.titleExcel = 'Không xác định';
            break;
        }
        this.apiParams = { ...this.param };
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    this.stopPolling();
  },
  validations: {},
  methods: {
    checkPermissions,
    exportExcel() {
      return this.withSubmitLock('export', () => this.doExportExcel());
    },
    async doExportExcel() {
      if (this.selectedMisa || this.selectedFast) {
        
        return this.exportToExcelFastMisa();
      }
      return this.exportToExcelStream();
    },
    async exportToExcelStream() {
      this.isDownloading = true;

      const apiParams = this.getParamFilters();

      if (!apiParams) {
        this.isDownloading = false;
        return;
      }
      try {
        const response = await ApiService.query('bills/export-excel', {
          params: apiParams,
        });
        if (response.status) {
          this.getHistoryExportExcel();
          return makeToastSuccess(
            'File đang được tải vui lòng chờ trong ít phút !!',
          );
        }
      } catch (error) {
        return makeToastFaile(error.data.message || 'Lỗi');
      } finally {
        this.isDownloading = false;
        this.$nprogress.done();
        this.getHistoryExportExcel();
      }
    },

    async exportToExcelFastMisa() {
      try {
        const apiParams = this.getParamFilters();

        const response = await ApiService.query('bills/export-excel', {
          params: apiParams,
          responseType: 'blob',
        });
        const fileName = fileDownload.getFileName(response);
        fileDownload.createFile(response.data, fileName);
      } catch (error) {
        const responseObj = JSON.parse(await error.response.data.text());
        return makeToastFaile(responseObj.message || 'Lỗi');
      } finally {
        this.isDownloading = false;
        this.$nprogress.done();
        this.getHistoryExportExcel();
      }
    },
    async getHistoryExportExcel() {
      try {
        const { data } = await ApiService.query('bills/history-export-excel');
        if (data.status) {
          // this.histories = data.data;
          this.histories = await Promise.all(
            data.data
              .filter((item) => item.url)
              .map(async (item) => {
                let process = 0;

                if (
                  +item.processingStatus ===
                    PROCESSING_DOWNLOAD_STATUS.COMPLETED ||
                  +item.processingStatus === PROCESSING_DOWNLOAD_STATUS.ERROR
                ) {
                  process = 100;
                } else {
                  const data = await this.getProcessDownload(item.id);
                  await this.startPolling(item.id);
                  process = data.process;
                }

                return {
                  ...item,
                  name: item['url'] ? item['url'].split('/').pop() : '',
                  process: process,
                };
              }),
          );
        }
      } catch (error) {
        console.log(error);

        // const responseObj = JSON.parse(await error.response.data.text());
        return makeToastFaile(error.data.message || 'Lỗi');
      }
    },
    async downloadExcel(id) {
      try {
        const response = await ApiService.query(
          `/bills/download-excel?id=${id}`,
          {
            responseType: 'blob',
          },
        );
        const fileName = fileDownload.getFileName(response);
        fileDownload.createFile(response.data, fileName);
        this.getHistoryExportExcel();
      } catch (err) {
        // const responseObj = JSON.parse(await err.response.data.text());
        return makeToastFaile(err.data.message || 'Lỗi');
      }
    },
    cancelDownload(id) {
      return this.withSubmitLock('cancel-' + id, () =>
        this.doCancelDownload(id),
      );
    },
    async doCancelDownload(id) {
      try {
        const response = await ApiService.delete(`bills/cancel-process-excel?id=${id}`);
        if (response.data.status) {
          makeToastSuccess(response.data.message);
          // Stop polling for this ID
          if (this.pollingIntervals[id]) {
            clearInterval(this.pollingIntervals[id]);
            delete this.pollingIntervals[id];
          }
          // Refresh the history  
          this.histories = this.histories.filter((item) => item.id !== id).map((item)=> item);
        }
      } catch (error) {
        return makeToastFaile(error.data?.message || 'Lỗi khi dừng tải xuống');
      }
    },
    async getProcessDownload(id) {
      try {
        const { data } = await ApiService.get(`bills/process-excel?id=${id}`);
        return data.data;
      } catch (error) {
        console.error('Error fetching progress:', error);
      }
    },
    async startPolling(id) {
      if (this.pollingIntervals[id]) {
        return;
      }
      // Khởi chạy polling để lấy progress
      this.pollingIntervals[id] = setInterval(async () => {
        try {
          const data = await this.getProcessDownload(id);
          console.log(`Progress for ID ${id}:`, data);
          const index = this.histories.findIndex((item) => item.id === id);
          if (index !== -1) {
            this.histories = this.histories.map((item) =>
              item.id === id ? { ...item, process: data.process } : item,
            );

            // Nếu process đã hoàn thành, dừng polling
            if (+data.process === 100) {
              clearInterval(this.pollingIntervals[id]);
              delete this.pollingIntervals[id];
              this.getHistoryExportExcel();
            }
          }
        } catch (error) {
          // Xóa interval nếu gặp lỗi
          clearInterval(this.pollingIntervals[id]);
          delete this.pollingIntervals[id];
        }
      }, 5000);
    },
    stopPolling() {
      Object.keys(this.pollingIntervals).forEach((id) => {
        clearInterval(this.pollingIntervals[id]);
      });
      this.pollingIntervals = {};
    },
    getValuesMultiSelect(arr, prop) {
      return arr.reduce((accumulator, currentValue) => {
        if (currentValue.checked) accumulator.push(currentValue[prop]);
        return accumulator;
      }, []);
    },
    getParamFilters() {
      const DATE_FORMAT = 'DD/MM/YYYY';
      const DATE_DB_FORMAT = 'YYYY-MM-DD';
      const fromDate = this.apiParams.fromDate
        ? moment(this.apiParams.fromDate, DATE_FORMAT).format(DATE_DB_FORMAT)
        : '1991-01-01';

      const toDate = this.apiParams.toDate
        ? moment(this.apiParams.toDate, DATE_FORMAT).format(DATE_DB_FORMAT)
        : moment().format('YYYY-MM-DD');

      const apiParams = {
        fromDate: fromDate,
        toDate: toDate,
        types: this.types,
        selectedMisa: this.selectedMisa || null,
        selectedFast: this.selectedFast || null,
      };

      if (this.selectedListExcel === 'filter') {
        const diff = this.getDaysDiff(apiParams.fromDate, apiParams.toDate);

        if (
          diff > 100 &&
          (!this.apiParams.searchCustomer ||
            this.apiParams.searchCustomer.trim() === '')
        ) {
          makeToastFaile('Vui lòng chọn khoảng thời gian trong vòng 3 tháng!');
          return null;
        }
        const productSearch = this.apiParams.productSearch || '';

        if (productSearch.length < 5 && productSearch.length > 1) {
          makeToastFaile('Tên sản phẩm phải từ 5 kí tự trở lên');
          return null;
        }
        const criteriaIds = this.param.criteriaIds?.map(({ code }) => code);

        const storeIds = this.param.storeIds?.map(({ code }) => code);

        return {
          ...this.apiParams,
          ...apiParams,
          productSearch: productSearch ? productSearch.trim() : null,
          criteriaIds: criteriaIds,
          storeIds: storeIds,
          selectedMisa: this.selectedMisa || null,
          selectedFast: this.selectedFast || null,
        };
      }

      const diff = this.getDaysDiff(apiParams.fromDate, apiParams.toDate);
      if (diff > 32) {
        makeToastFaile('Vui lòng chọn khoảng thời gian trong vòng 1 tháng!');
        return null;
      }

      return apiParams;
    },
    getDaysDiff(startDate, endDate, dateFormat = 'YYYY-MM-DD') {
      const getDateAsArray = (date) => {
        return moment(date.split(/\D+/), dateFormat);
      };
      return (
        getDateAsArray(endDate).diff(getDateAsArray(startDate), 'days') + 1
      );
    },
  },
};
</script>
